import React, { useContext, useEffect } from 'react';
import './StaffLogin.scss';
import caletaTexto from '../../assets/CaletaEnLineaLogoV3.svg';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { uiContext } from '../common';
import { Fragment } from 'react';
import flechaImg from '../../assets/flecha.svg';
import {API} from '../../services/api'

export function StaffLoginPage({isChangePassword}){
    /**
     * Vista login del adminsitrador
     * Hay un formulario donde pide el email y password y estos datos son validados en el servidor
     */
    const uicontext = useContext(uiContext);
    const history = useHistory();
    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");

    const [formState, setFormState] = useState(0);

    const [showIncorrectPasswordModal, setShowIncorrectPasswordModal] = useState(false);
    const [showForgotpasswordModal, setShowForgotpasswordModal] = useState(false);

    const [newPassword, setNewPassword] = useState("");
    const [repeatNewPassword, setRepeatNewPassword] = useState("");

    useEffect(() => {
        if (isChangePassword === true) {
            setFormState(2);
        }
    }, [])

    const login = () => {
        uicontext.showLoader();
        /**
         * Login del administrador
         * Se hace el llamado al servicio /staffusers/register-staff-user-session
         */
        API.postRegisterStaffUserSession(user,password)
            .then(x =>{
                if(!x.key){
                    setShowIncorrectPasswordModal(true);
                    setPassword("");
                    uicontext.hideLoader();
                    return;
                }
                localStorage.removeItem("sessionToken");
                localStorage.removeItem("userId");
                localStorage.setItem("sessionToken", x.key);
                localStorage.setItem("staffUserId", x.userId);

                uicontext.hideLoader();
                history.push("/admin/user-requests");
            })
            .catch(x => {
                uicontext.hideLoader();
            })

    }

    const forgotPassword = () => {
        uicontext.showLoader();
        /**
         * Recuperar contraseña
         * Se hace el llamado al servicio /staffusers-forgot-password
         */
        API.putForgotPasswordStaffUser(user)
            .then(x => {
                if(x.email){
                    setUser("");
                    setPassword("");
                    setFormState(0);
                    setShowForgotpasswordModal(true);
                    uicontext.hideLoader();
                    history.push("/staff-login");
                }else{
                    uicontext.hideLoader();
                    alert('Datos inválidos!')
                }
            })
    }

    const changePassword = () => {
        uicontext.showLoader();

        let sessionToken = localStorage.getItem("sessionToken");
        if (sessionToken !== null) {
            window.caletaEnLineaAPI.callService('getUserBySessionKey', {
                sessionKey: sessionToken,
            }, function callback(error, sesionUser) {
                window.caletaEnLineaAPI.callService('changePassword', {
                    userId: sesionUser.responseJSON._id,
                    oldPassword: password,
                    newPassword: newPassword
                }, function callback(error, changePasswordResponse) {
                    if (error || changePasswordResponse.status !== 200) {
                        console.warn({ error: "error", message: error });
                        uicontext.hideLoader();
                        return;
                    }

                    setUser("");
                    setPassword("");
                    setFormState(0);
                    uicontext.hideLoader();
                });
            });
        } else {
            uicontext.hideLoader();
            setFormState(0);
            setPassword("");
            setUser("");
        }
    }

    return (
        <Fragment>
            <div className="loginMasterContainer">
                <div className="div0">
                </div>
                <div className="div1">
                    <div className="returnButton">
                        <button onClick={() => { history.push("/home"); }}>
                            <img src={flechaImg} alt=""/>
                            <span>Volver</span>
                        </button>
                    </div>

                    <img className="caletaTexto" src={caletaTexto} alt="" />
                    {formState === 0 && <form className="loginForm" onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        login();
                    }}>
                        <div className="loginFormHeader">
                            <span>Bienvenido a Caleta en Línea</span>
                        </div>

                        <span className="fieldName">Email</span>
                        <input required className="input" value={user} type="text" onChange={(event) => { setUser(event.target.value); }} placeholder="Escribe tu nombre de usuario" />

                        <span className="fieldName">Clave</span>
                        <input required className="input" value={password} type="password" onChange={(event) => { setPassword(event.target.value); }} placeholder="Escribe tu clave" />

                        <span onClick={() => { setUser(""); setPassword(""); setFormState(1); }} 
                        className="forgotPassword">¿Olvidaste tu contraseña?</span>

                        <div className="loginDiv">
                            <input type="submit" className="loginButton" value="Entrar" />
                        </div>
                        <span onClick={() => { history.push("/home"); }} className="returnSpan HideReturnSpan">Volver</span>
                    </form>}

                    {formState === 1 && <form className="loginForm" onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        forgotPassword();
                    }}>
                        <div className="loginFormHeader">
                            <span>Bienvenido a caleta en línea</span>
                        </div>

                        <span className="fieldName">Correo electrónico</span>
                        <input required className="input" type="text" value={user} onChange={(event) => { setUser(event.target.value); }} placeholder="Ingresa tu correo electrónico" />

                        <div className="loginDiv">
                            <input type="submit" className="loginButton" value="Enviar" />
                        </div>
                        <span onClick={() => { setUser(""); setPassword(""); setFormState(0); }} className="returnSpan">Volver</span>
                    </form>}

                    {formState === 2 && <form className="loginForm" onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        //forgotPassword();
                        changePassword();
                    }}>
                        <div className="loginFormHeader">
                            <span>Cambiar contraseña</span>
                        </div>

                        <span className="fieldName">Contraseña actual</span>
                        <input required className="input" type="password" value={password} onChange={(event) => { setPassword(event.target.value); }} />

                        <span className="fieldName">Contraseña nueva</span>
                        <input required className="input" type="password" value={newPassword} onChange={(event) => { setNewPassword(event.target.value); }} />

                        <span className="fieldName">Vuelve a escribir la contraseña nueva</span>
                        <input required className="input" type="password" value={repeatNewPassword} onChange={(event) => { setRepeatNewPassword(event.target.value); }} />

                        <div className="forgotRegisterButton">
                            <span onClick={() => { setUser(""); setPassword(""); setFormState(1); }} className="forgotPassword">¿Olvidaste tu contraseña?</span>
                            <span onClick={() => { }} className="registerSpan"></span>
                        </div>

                        <div className="loginDiv">
                            <input type="submit" className="loginButton" value="Guardar cambios" />
                        </div>
                    </form>}
                </div>
            </div>
            <div className={"loginMasterContainer-PasswordModal"}>
                {showIncorrectPasswordModal === true && <div className="passwordModal">
                    <span className="modalTitle">Clave incorrecta</span>
                    <span className="modalContent">La clave introducida no es correcta.</span>
                    <button onClick={() => { setShowIncorrectPasswordModal(false); }}>Volver a intentarlo</button>
                </div>}

                <div onClick={() => { setShowIncorrectPasswordModal(false); setShowForgotpasswordModal(false); }} className={(showIncorrectPasswordModal === true || showForgotpasswordModal === true ? "passwordModalBackground-visible" : "passwordModalBackground-hidden") + " passwordModalBackground"}>
                </div>

                {showForgotpasswordModal === true && <div className="passwordModal">
                    <span className="modalTitle">Correo de recuperacion enviado</span>
                    <span className="modalContent">Se ha enviado una clave de recuperación a su correo electrónico.</span>
                    <button onClick={() => { setShowForgotpasswordModal(false); }}>Cerrar</button>
                </div>}
            </div>
        </Fragment>
    )
}
